import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ContactPanelContext = createContext(null);

export function ContactPanelProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);
  return <ContactPanelContext.Provider value={value}>{children}</ContactPanelContext.Provider>;
}

export function useContactPanel() {
  return useContext(ContactPanelContext) || { isOpen: false, open() {}, close() {} };
}
